import anime from 'animejs';

const header = document.querySelector('header');
const hamburger = document.querySelector('.mobile-nav__hamburger');
const mobileNav = document.querySelector('.mobile-nav__container');

const calculateMenuHeight = () => {
  const numOfItems = document.querySelectorAll('.mobile-nav__menu li:not(.highlighted)').length;
  const numOfItemsHighlighted = document.querySelectorAll('.mobile-nav__menu li.highlighted').length;
  const itemHeight = document.querySelector('.mobile-nav__menu li:not(.highlighted)').scrollHeight;
  const highlightedItemHeight = document.querySelector('.mobile-nav__menu li.highlighted').scrollHeight;
  
  const mobileMenu = document.querySelector('.mobile-nav__menu');
  const mobileMenuStyles = window.getComputedStyle(mobileMenu);
  const mobileMenuPadding = parseInt(mobileMenuStyles.getPropertyValue('padding-top')) + parseInt(mobileMenuStyles.getPropertyValue('padding-bottom'));
  const mobileMenuBorder = parseInt(mobileMenuStyles.getPropertyValue('border-top-width')) + parseInt(mobileMenuStyles.getPropertyValue('border-bottom-width'));

  return itemHeight * numOfItems + highlightedItemHeight * numOfItemsHighlighted + mobileMenuPadding + mobileMenuBorder;
}

const openMobileMenu = () => {
  const calculatedHeight = calculateMenuHeight();

    anime({
      targets: mobileNav,
      height: calculatedHeight,
      complete: () => {
        mobileNav.setAttribute('aria-expanded', 'true');
      }
    });
    header.classList.add('header__section--bottom-border');
    hamburger.classList.add('is-active');
  };
  
  const closeMobileMenu = () => {
    anime({
      targets: mobileNav,
      height: 0,
      easing: 'linear',
      duration: 200,
      complete: () => {
        mobileNav.setAttribute('aria-expanded', 'false');
        header.classList.remove('header__section--bottom-border');
      }
    });
    hamburger.classList.remove('is-active');
};

const toggleMobileMenu = () => {
    const expanded = mobileNav.getAttribute('aria-expanded') === 'true' ? true : false;

    if (!expanded) {
        openMobileMenu();
    } else {
        closeMobileMenu();
    }
};

hamburger.addEventListener('click', toggleMobileMenu);
